<ng-container *ngIf="isLoading">
  <div class="loading-indicator loading-indicator--floating">
    <span class="loading-indicator__pip"></span>
    <span class="loading-indicator__pip"></span>
    <span class="loading-indicator__pip"></span>
  </div>
</ng-container>
